// assets
import { IconDashboard, IconKey } from "@tabler/icons";

// constant
const icons = { IconDashboard, IconKey };

// ==============================|| QUICK ACCESS MENU ITEMS ||============================== //

const quickaccess = {
    id: "quickaccess",
    title: "Quick Access",
    type: "group",
    children: [
        {
            id: "default",
            title: "Dashboard",
            type: "item",
            url: "/dashboard",
            icon: icons.IconDashboard,
            breadcrumbs: false,
        },
    ],
};

export default quickaccess;
